import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import mapStateToProps from "./mapStateToProps";
import mapDispatchToProps from "./mapDispatchToProps";
// import ListadoDeSolicitudesAprobadas from "./SolicitudesEnviadas";
// import ListadoDeSolicitudesNuevas from "./SolicitudesNuevas/index";
// import ListadoDeSolicitudesRechazadas from "./SolicitudesRechazadas";
// import ListadoDeSolicitudesCasosEspeciales from "./SolicitudesCasosEspeciales";
// import ListadoDeSolicitudesTSEVirtual from "./SolicitudesTSEVirtual";
// import ListadoDesolicitudesReportadosAInformaticaInconsistencias from "./SolicitudesConInconsistencias";
import Title from "components/Title";
import CitasNuevas from "./CitasNuevas";
import CitasCanceladas from "./CitasCanceladas";
import CitasFinalizadas from "./CitasFinalizadas";
//No me gusta el título con el ícono todo grande.
//import Title from "components/TitleWithIcon";
import PeopleIcon from "@material-ui/icons/People";
import { Box, Tab, Tabs, AppBar, makeStyles } from "@material-ui/core";
import { CheckCircleOutline, LibraryAdd, Assignment, HighlightOff } from "@material-ui/icons";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`scrollable-force-tabpanel-${index}`} 
            aria-labelledby={`scrollable-force-tab-${index}`}{...other}
        >
            {value === index && (<Box p={3}><div>{children}</div></Box>)}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
    backgroundColorTab: {
        backgroundColor: "#ededed",
    },
}));

function ScrollableTabsButtonForce(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(props.tabValueInitial);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    var authenticated = props.authenticated;
    //   useEffect(() => {
    //     if (props.idSolicitudTSEVirtualEnviada) {
    //       handleChange({}, 4);
    //     }
    //   }, [props.idSolicitudTSEVirtualEnviada]);
    return (
        <div className={classes.root}>
        {/* <Title title="Citas de Empadronamiento" icon={"/menu/Document.png"} /> */}
            <Title title="Citas de Empadronamiento y Actualización de Datos" icon={<PeopleIcon/>}/>
            <AppBar position="static" color="inherit" elevation={0}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="on"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="scrollable force tabs example"
                >
                <Tab
                    label="Citas Nuevas"
                    icon={<LibraryAdd />}
                    {...a11yProps(0)}
                />
                    <Tab
                    label="Citas Canceladas"
                    icon={<HighlightOff />}
                    {...a11yProps(1)}
                />
                <Tab
                    label="Citas Finalizadas"
                    icon={<HighlightOff />}
                    {...a11yProps(2)}
                />
                {/* <Tab label="Solicitudes Aprobadas" icon={<CheckCircleOutline />} {...a11yProps(1)} />
                            <Tab label="Solicitudes Rechazadas" icon={<HighlightOff />} {...a11yProps(2)} />
                            <Tab label="Solicitudes Casos Especiales" icon={<HighlightOff />} {...a11yProps(3)} />
                            <Tab label="Solicitudes TSE Virtual" icon={<Assignment />} {...a11yProps(4)} />
                            <Tab label="Solicitudes Con Inconsistencias" icon={<Assignment />} {...a11yProps(5)} /> */}
                </Tabs>
            </AppBar>
            {/* Nuevas Solicitudes */}
            <TabPanel value={value} index={0} className={classes.backgroundColorTab}>
                <CitasNuevas
                //   authenticated={authenticated}
                //   currentUser={props.currentUser}
                />
            </TabPanel>
            <TabPanel value={value} index={1} className={classes.backgroundColorTab}>
                <CitasCanceladas
                //   authenticated={authenticated}
                //   currentUser={props.currentUser}
                />
            </TabPanel>
            <TabPanel value={value} index={2} className={classes.backgroundColorTab}>
                <CitasFinalizadas
                //   authenticated={authenticated}
                //   currentUser={props.currentUser}
                />
            </TabPanel>            
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(ScrollableTabsButtonForce);
